import { TopLevelSpec as VegaLiteSpec } from 'vega-lite';
import { Scale } from 'vega-lite/build/src/scale';
import { TimeUnit } from 'vega-lite/build/src/timeunit';
import { liteBaseConfig } from '../vegaShared';

export interface IBarOptions {
  data: any[];
  xField: string;
  color?: string;
  colorScale?: Scale;
  colorField: string;
  yField: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
  xLabels?: boolean;
  yLabels?: boolean;
  yFormat?: string;
  width?: number | 'container';
  height?: number | 'container';
}

export const genOfferOutcomeBar = (options: IBarOptions): VegaLiteSpec => {
  const xAxis = {
    labelAngle: 0,
    title: options.xAxisTitle || null,
    labels: !!options.xLabels,
    domain: !!options.xLabels,
    ticks: !!options.xLabels,
    labelFontWeight: 600 as 600,
    labelFontSize: 11,
  };
  const yAxis = {
    title: options.yAxisTitle || null,
    labels: !!options.yLabels,
    domain: !!options.yLabels,
    ticks: !!options.yLabels,
    format: options.yFormat || '0.2s',
  };
  const config = {
    ...liteBaseConfig(),
  };
  const baseSpec: VegaLiteSpec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
    autosize: 'fit',
    width: options.width || 'container',
    height: options.height || 100,
    // @ts-ignore
    mark: { type: 'bar', tooltip: true, cornerRadiusBottomRight: 6, cornerRadiusTopRight: 6, ...(options.color && { fill: options.color }) },
    config,
    ...(options.colorScale?.domain && {
      transform: [
        {
          // @ts-ignore
          calculate: `indexof(['${options.colorScale.domain.join("', '")}'], datum.${options.colorField})`,
          as: 'order',
        },
      ],
    }),
    encoding: {
      y: { field: options.xField, type: 'nominal', axis: xAxis, band: 0.7, sort: '-x' },
      x: { field: options.yField, axis: yAxis, type: 'quantitative' },
      ...(options.colorField && { color: { field: options.colorField, legend: null, scale: options.colorScale || {} } }),
      ...(options.colorScale?.domain && { order: { field: 'order', type: 'ordinal' } }),
    },
    data: { values: options.data },
  };
  return baseSpec;
};
